// UI strings. Trellure ships in English only for now; the second locale
// was removed rather than left as an unmaintained copy.
export const translations = {
  en: {
    nav_home: "Home",
    nav_browse: "Browse",
    nav_library: "My Library",
    nav_admin: "Admin",
    search_placeholder: "Search titles, authors, narrators...",
    signin: "Sign in",
    signup: "Sign up",
    signout: "Sign out",
    account: "Account",
    hero_cta: "Start listening",
    hero_explore: "Explore catalog",
    view_audiobook: "View audiobook",
    redeem: "Redeem a code",
    section_featured: "Featured audiobooks",
    section_bestsellers: "Bestsellers",
    section_new: "New releases",
    section_categories: "Browse by category",
    section_because: "Because you listen",
    see_all: "See all",
    add_library: "Add to Library",
    in_library: "In your Library",
    buy_now: "Buy now",
    play_sample: "Play sample",
    listen_now: "Listen now",
    owned: "Owned",
    locked: "Locked",
    unlock_hint: "Purchase or ask an admin to unlock",
    chapters: "Chapters",
    narrated_by: "Narrated by",
    written_by: "By",
    length: "Length",
    release: "Release",
    rating: "Rating",
    ratings: "ratings",
    overview: "Overview",
    price: "Price",
    catalog: "Catalog",
    filters: "Filters",
    all_categories: "All categories",
    sort_by: "Sort by",
    sort_popular: "Most popular",
    sort_newest: "Newest",
    sort_rating: "Top rated",
    sort_price_low: "Price: Low to High",
    sort_price_high: "Price: High to Low",
    results: "results",
    library_title: "My Library",
    library_empty: "Your library is empty. Explore the catalog and start listening.",
    continue_listening: "Continue listening",
    // auth
    welcome_back: "Welcome back",
    create_account: "Create your account",
    email: "Email",
    password: "Password",
    full_name: "Full name",
    login_btn: "Sign in",
    register_btn: "Create account",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    // admin
    admin_dashboard: "Dashboard",
    admin_books: "Audiobooks",
    admin_chapters: "Chapters",
    admin_authors: "Authors",
    admin_users: "Users",
    admin_entitlements: "Entitlements",
    admin_bunny: "Bunny Assets",
    total_books: "Total audiobooks",
    total_users: "Total users",
    total_chapters: "Total chapters",
    published: "Published",
    new_book: "New audiobook",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    title: "Title",
    author: "Author",
    narrator: "Narrator",
    category: "Category",
    status: "Status",
    actions: "Actions",
    manage_chapters: "Manage chapters",
    bunny_asset: "Bunny asset ID / URL",
    cover_url: "Cover image URL",
    grant_access: "Grant access",
    revoke: "Revoke",
    footer_tag: "Premium audiobooks, beautifully told.",
    added_to_library: "Added to your library",
    purchase_success: "Purchase successful. Enjoy your audiobook!",
    reviews: "Reviews & ratings",
    write_review: "Write a review",
    your_review: "Your review",
    story_rating: "Story",
    performance_rating: "Performance",
    overall_rating: "Overall",
    review_title: "Headline",
    review_body: "Share your thoughts…",
    submit_review: "Submit review",
    no_reviews: "No reviews yet. Be the first to review this audiobook.",
    review_own_hint: "Add this audiobook to your library to leave a review.",
    wishlist: "Wish List",
    add_wishlist: "Add to Wish List",
    in_wishlist: "In your Wish List",
    more_by_author: "More by",
    based_on: "based on",
  },

};
